import React, {JSX, useEffect } from 'react';
import CloseButton from 'react-bootstrap/CloseButton';
import Modal from 'react-bootstrap/Modal';

interface GenericModalSchema {
  modalState: boolean;
  handler: () => void;
  children: React.ReactNode; // modal body
  showFooter: boolean;
  footerNode?: React.ReactNode;
  height?: string;
  width?: string;
  noCloseButton?: boolean;
  backDrop?: boolean;
  fixedWidth?: string;
  bodyPadding?:string;
  id?:string;
  backgroundColor?:string;
}

const AccessoryModal = ({
  modalState,
  handler,
  showFooter,
  footerNode,
  children,
  width,
  height,
  noCloseButton,
  backDrop,
  fixedWidth,
  bodyPadding,
  id,
  backgroundColor
}: GenericModalSchema): JSX.Element => {
  useEffect(() => {
    const elem: any = document && document.querySelector('.modal-dialog');

    if (elem) {
      elem.style.maxWidth = width;
      elem.style.width = fixedWidth;
      // For mobile devices, add equal left/right margins
      if (window.innerWidth <= 767) {
        elem.style.margin = '1.75rem auto';
      } else {
        elem.style.padding = '0';
      }
    }
    const elem1: any = document.querySelector('.modal-content');
    if (elem1) {
      elem1.style.minHeight = height;
      elem1.style.backgroundColor=backgroundColor
    }

    const elem2: any = document.querySelector('.modal-body');
    if(elem2 && bodyPadding){
      elem2.style.padding =bodyPadding;
    }
  }, [height]);
  return (
    <Modal
      centered
      contentClassName={`${id==='mobile-benefits' ? 'benefits-container':''}`}
      show={modalState}
      onHide={handler}
      backdrop={backDrop ? backDrop : 'static'}
      keyboard={false}
      dialogClassName='sr-custom-modal'
    >
      <Modal.Header>
        <div style={{ display: noCloseButton ? 'none' : '' }}>
          <CloseButton className='sr-modal-close-accessory' onClick={handler} />
        </div>
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>

      {showFooter && <Modal.Footer>{footerNode}</Modal.Footer>}
    </Modal>
  );
};

export default AccessoryModal;
